import { Injectable } from '@angular/core';
import { Route, Router, CanLoad } from '@angular/router';

import { Store } from '@ngxs/store';
import { CanAccessState } from '@shared/store/canAccess/canAccess.state';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AddTemplateGuard implements CanLoad {
  constructor(private router: Router, private store: Store) {}

  canLoad(route: Route): boolean | Promise<boolean> | Observable<boolean> {
    if (this.store.selectSnapshot(CanAccessState.canAccessaddTemplate)) {
      return true;
    }
    this.router.navigate(['templates/lista-templates']);
    return false;
  }
}
